import React from 'react';
import { Redirect } from 'expo-router';

// REQUEST/chat de negociação de recorrência desativado no front por ora.
// Tela original preservada abaixo para reativar depois.
// Ao reativar: "Denunciar" e "Bloquear" no cabeçalho são obrigatórios na App
// Store (1.2) — a API já tem POST conversations/:id/report e /block.
export default function ClientChatThreadScreen() {
  return <Redirect href="/(tabs)/(client)/appointments" />;
}

/*
import { View } from 'react-native';
import { router, useLocalSearchParams } from 'expo-router';

import { DetailHeader } from '@/components/ui/detail-header';
import { ChatThread } from '@/components/schedule/chat-thread';
import { MESSAGE_SENDER } from '@/types/message-sender';
import { useThemedHex } from '@/hooks/use-theme-colors';

export default function ClientChatThreadScreen() {
  const th = useThemedHex();
  const { id } = useLocalSearchParams<{ id: string }>();

  return (
    <View style={{ flex: 1, backgroundColor: th('#fff') }}>
      <DetailHeader title="Conversa" onBack={() => router.back()} />
      {id ? (
        <ChatThread conversationId={id} viewerRole={MESSAGE_SENDER.CLIENT} />
      ) : null}
    </View>
  );
}
*/
